import React, { useState, useEffect } from 'react'
import Marquee from "react-fast-marquee";
import * as ctf from "contentful";
const HomeLogoSlider = () => {

    const [logs, setLogs] = useState([]);
    const client = ctf.createClient({
        space: "fdtw7gymput4",
        accessToken: "-b6ZWs0OGwtdJjGTqdBxGGG5D5iITPNdSgVKo4stF7E",
    });

    useEffect(() => {
        fetchDataHome();
    }, []);

    const fetchDataHome = async () => {
        try {
            const resp = await client.getEntries({ content_type: "homePageLogo" });
            setLogs(resp.items);
        } catch (error) {
            console.log(error);
        }
    };

    const MarqueeLogo = logs[0]?.fields?.frontLogos

    return (
        <div className='home_page_marque_logo' style={{ display: 'flex', justifyContent: 'flex-end' }} >
            {/* {/* <Marquee className='home_marque'> */}
            {MarqueeLogo && MarqueeLogo.map((item) => {
                return (
                    <div className='logos'>
                        <img src={`https:${item?.fields?.file?.url}`} alt="" />
                    </div>
                )
            })}
            {/* </Marquee> */}
        </div>
    )
}

export default HomeLogoSlider